import { ModelFactory } from "../../ModelFactory";
import { parseItemPermissions, PermissionMap } from "../../common/models/PermissionMap";
import { DeploymentStatus } from "../../common/models/DeploymentStatus";

export type CertificateType = "acme_certificate"
export type ChallengeType = "http-01" | "dns-01"
export type KeyType = "rsa" | "ecdsa"
export type KeyLength = "256" | "384" | "512" | "4096"

export class Certificate {
  constructor(
    public readonly id: string,
    public readonly type: CertificateType,
    public readonly customer: string,
    public readonly displayName: string,
    public readonly deploymentStatus: DeploymentStatus,
    public readonly windhostingServer: string,
    public readonly domains: string[],
    public readonly challengeType: ChallengeType,
    public readonly keyType: KeyType,
    public readonly keyLength: KeyLength,
    public readonly validFrom: string,
    public readonly validUntil: string,
    public readonly challenges: { domain: string; value: string }[],
    public readonly permissions: PermissionMap | null,
  ) { }
}

class CertificateFactory extends ModelFactory<Certificate> {
  protected fromJson(json: any): Certificate {
    return new Certificate(
      json['id'],
      json['type'],
      json['customer_uuid'],
      json['display_name'],
      json['deployment_status'],
      json['windhosting_server_uuid'],
      json['domains'],
      json['challenge_type'],
      json['key_type'],
      json['key_length'],
      json['valid_from'],
      json['valid_until'],
      json['challenges'] ? json['challenges'] : [],
      parseItemPermissions(json['permissions']),
    );
  }
}
export const certificateFactory = new CertificateFactory();
